import { ImageViewerPage } from '@components/enrollments/courses/course_contents/image_viewer/ImageViewerPage'
import { CourseContentsProvider } from '@contexts/CourseContentsContext'
import { CourseProvider } from '@contexts/CourseContext'
import { EnrollmentProvider } from '@contexts/EnrollmentContext'
import { ModulesProvider } from '@contexts/ModulesContext'
import { AppLayout } from '@layouts/AppLayout'
import { router } from 'expo-router'

export default function CourseContents() {
  return (
    <CourseContentsProvider>
      <CourseProvider>
        <EnrollmentProvider>
          <CourseContentsProvider>
            <ModulesProvider>
              <AppLayout
                backRoute={{
                  label: 'Voltar',
                  back: () => router.back(),
                }}
                hasFooter={false}
                hasPaddingBottom={false}
              >
                <ImageViewerPage />
              </AppLayout>
            </ModulesProvider>
          </CourseContentsProvider>
        </EnrollmentProvider>
      </CourseProvider>
    </CourseContentsProvider>
  )
}
